import React, { useContext } from 'react';
import { DocumentVerificationContext, DocumentVerificationStep } from '../../containers/DocumentVerification';
import Trulioo from '../../services/trulioo';
import { CaptureType } from '../../services/trulioo/contants';
import { AppContext } from '../../containers/AppProvider';
import { PhotosActionTypes } from '../../containers/AppProvider/reducers';

const ScanFrontImageStart = (): JSX.Element => {
  const { dispatch } = useContext(AppContext);
  const { onChangeStep, onChangeNumOfAttempts, attempts } = useContext(DocumentVerificationContext);

  const handleImgSuccess = (res: string): void => {
    dispatch({
      type: PhotosActionTypes.AddFrontImage,
      payload: {
        frontImage: res
      }
    });
    onChangeNumOfAttempts(0);
    onChangeStep(DocumentVerificationStep.ScanFrontImageComplete);
  };

  const handleError = (error: string): void => {
    console.log(error);
    onChangeNumOfAttempts(attempts + 1);
    onChangeStep(DocumentVerificationStep.ScanFrontImageError);
  };

  return (
    <Trulioo
      captureType={CaptureType.DocumentFront}
      isAuto={true}
      onImgSuccess={handleImgSuccess}
      onError={handleError}
    />
  );
};

export default ScanFrontImageStart;
